export const MESSAGE_SEND = 'MESSAGE_SEND';
export const MESSAGE_RECEIVE = 'MESSAGE_RECEIVE';
export const MESSAGE_REPLY_NOTIFICATION = 'MESSAGE_REPLY_NOTIFICATION';
export const MESSAGE_ACCEPT = 'MESSAGE_ACCEPT';
export const MESSAGE_START = 'MESSAGE_START';
export const MESSAGE_FINISH = 'MESSAGE_FINISH';
export const MESSAGE_FINISH_ALL = 'MESSAGE_FINISH_ALL';
export const MESSAGE_HISTORY = 'MESSAGE_HISTORY';
export const MESSAGE_MISS = 'MESSAGE_MISS';
export const MESSAGE_TYPING = 'MESSAGE_TYPING';
export const MESSAGE_TYPING_START = 'MESSAGE_TYPING_START';
export const MESSAGE_TYPING_STOP = 'MESSAGE_TYPING_STOP';